import type { RowClassParams } from 'ag-grid-community';
import clsx from 'clsx';
import { memo, useMemo } from 'react';

import type { DataTableProps } from '@shared/DataTableGrid';
import DataTableGrid from '@shared/DataTableGrid';
import { useTranslateFn } from '@shared/Translate';
import type { Standing } from '@shared-types/standing.types';
import { omit } from '@utilities/collection-utils';

import * as classes from '../styles.module.scss';

export const TablePlace = (
  props: DataTableProps & {
    wrapperClassName?: string;
    splitTablePlaces: boolean;
    placeTitle?: string;
    placeSubTitle?: string;
    onlyHeader?: boolean;
    teamIds?: string[];
  },
) => {
  const { splitTablePlaces, placeTitle, placeSubTitle, rowData, wrapperClassName, onlyHeader = false, teamIds } = props;

  const t = useTranslateFn();

  const rowClassRules = useMemo(
    () => ({
      'selected-row': ({ data }: RowClassParams<Standing>) => teamIds?.includes(data?.team?.id),
    }),
    [teamIds],
  );

  const tableProps = useMemo<DataTableProps>(
    () => omit(props, 'splitTablePlaces', 'placeTitle', 'placeSubTitle', 'wrapperClassName', 'onlyHeader', 'teamIds'),
    [props],
  );

  if (!rowData?.length && !onlyHeader) return null;

  return (
    <div className={clsx(classes.newFormatTable, wrapperClassName)}>
      {splitTablePlaces && !!placeTitle && (
        <div className={classes.newFormatCaption}>
          {t(placeTitle)}
          {!!placeSubTitle && ` (${t(placeSubTitle)})`}
        </div>
      )}
      <DataTableGrid rowClassRules={rowClassRules} {...tableProps} />
    </div>
  );
};

export default memo(TablePlace);
